export default __webpack_public_path__ + "static/media/contact-general-support.e5e07232.svg";